import * as yup from 'yup';

const individual_investment_portfolio_validation_schema = yup.object().shape({

  sourceOfFundForThisAccount: yup
    .array()
    .min(1, 'please_select_an_option')
    .required('this_field_is_required'),

  haveYouWorkedInTheFinancialSectorInThePastFiveYears: yup
    .boolean()
    .required('this_field_is_required'),

  doYouHaveAnyOthePracticalExperienceRelatedToTheFinancialSector: yup
    .boolean()
    .required('this_field_is_required'),

  doYouHaveAnExistingPortfolio: yup
    .boolean()
    .required('this_field_is_required'),

  whatDoesYourOverallLocalAndInternationalInvestmentsRepresentAsAPercentageOfYourTotalNetAssetsId: yup
    .string()
    .required('please_select_an_option'),

  investmentKnowledgeAndExperienceId: yup
    .string()
    .required('please_select_an_option'),

  whatIsYourRiskAppetiteId: yup
    .string()
    .required('please_select_an_option'),

  forHowManyYearsHaveYouInvestedFininancialSecuritiesId: yup
    .object()
    .required('please_select_an_option'),

  productsPreviouslyInvestedIn: yup
    .string()
    .required('this_field_is_required'),

  professionalCertificates: yup
    .string()
    .required('this_field_is_required'),

  loanToInvestedMoneyRatio: yup
    .string()
    .required('this_field_is_required'),

  marginTransactionOverThePastFiveYears: yup
    .string()
    .required('this_field_is_required'),

  haveYouInvestedInFinancialSecuritiesOutsideSaudiArabia: yup
    .string()
    .required('this_field_is_required'),

  ifSecuritiesTransactionWereExecutedOutsideInWhichCountriesTransactionsExecutes: yup
    .string()
    .when('haveYouInvestedInFinancialSecuritiesOutsideSaudiArabia', {
      is: '1',
      then: schema =>
        schema.required('please_specify_the_countries'),
      otherwise: schema => schema.notRequired(),
    }),

  whatIsYourGeneraInvestmentObjectiveId: yup
    .array()
    .required('this_field_is_required'),

  preferredInvestmentCurrencies: yup
    .array()
    .min(1, 'select_one_prefered_currency')
    .required('this_field_is_required'),

  foreignCurrencyId: yup
    .array()
    .when('preferredInvestmentCurrencies', {
      is: val =>
        Array.isArray(val) &&
        val.some(item => Number(item.valueId) === 790),
      then: schema =>
        schema
          .min(1, 'select_one_foreign_currency')
          .required('this_field_is_required'),
      otherwise: schema => schema.notRequired(),
    }),

  whatIsYourExpectedTimeHorizonForRedeemingYourInvestment: yup
    .object()
    .required('this_field_is_required'),

  doYouHaveSufficientUnderstandingOfFinancialMarketsToMakeIndependentInvestmentDecisions: yup
    .boolean()
    .required('this_field_is_required'),

  toWhatExtentCanTheAdviceProvidedForThisInvestmentBeReliedUponId: yup
    .string()
    .required('this_field_is_required'),

  preferredLanguageForCorrespondenceId: yup
    .string()
    .required('this_field_is_required'),

  certificateId: yup
    .string()
    .required('this_field_is_required'),

  certificateOther: yup
    .string()
    .when('certificateId', {
      is: '803',
      then: schema =>
        schema
          .required('specify_other_certificate_recipient')
          .max(100, 'max_100_character'),
      otherwise: schema => schema.notRequired(),
    }),

  divedendId: yup
    .string()
    .required('where_to_send_dividends'),

  divedendOther: yup
    .string()
    .when('divedendId', {
      is: '803',
      then: schema =>
        schema
          .required('specify_other_dividend_recipient')
          .max(100, 'max_100_character'),
      otherwise: schema => schema.notRequired(),
    }),

  salesProceedId: yup
    .string()
    .required('where_to_send_sales_proceeds'),

  salesProceedOther: yup
    .string()
    .when('salesProceedId', {
      is: '803',
      then: schema =>
        schema
          .required('specify_other_sales_recipient')
          .max(100, 'max_100_character'),
      otherwise: schema => schema.notRequired(),
    }),

  anyOtherInformationOnTheClientFinancialSituation: yup
    .string()
    .required('this_field_is_required'),

  // Ideal Investment Portfolio
  clientIdealInvestmentPortfolioDepositsAndMurabaha: yup.string(),
  clientIdealInvestmentPortfolioDebitInstruments: yup.string(),
  clientIdealInvestmentPortfolioStocks: yup.string(),
  clientIdealInvestmentPortfolioRealEstate: yup.string(),
  clientIdealInvestmentPortfolioDerivativesContracts: yup.string(),
  clientIdealInvestmentPortfolioAlternativeInvestments: yup.string(),
  clientIdealInvestmentPortfolioInvestmentFunds: yup.string(),

  // Current Investment Portfolio
  clientCurrentInvestmentPortfolioDepositsAndMurabaha: yup.string(),
  clientCurrentInvestmentPortfolioDebitInstruments: yup.string(),
  clientCurrentInvestmentPortfolioStocks: yup.string(),
  clientCurrentInvestmentPortfolioRealEstate: yup.string(),
  clientCurrentInvestmentPortfolioDerivativesContracts: yup.string(),
  clientCurrentInvestmentPortfolioAlternativeInvestments: yup.string(),
  clientCurrentInvestmentPortfolioInvestmentFunds: yup.string(),

});

export default individual_investment_portfolio_validation_schema;
